import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'Have you wished you were dead or wished you could go to sleep and not wake up?',
    field: 'ssr_wishDead',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_wishDead_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_wishDead_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Have you actually had any thoughts of killing yourself?',
    field: 'ssr_thoughtsOfSuicide',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_thoughtsOfSuicide_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_thoughtsOfSuicide_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Have you thought about how you might do this?',
    field: 'ssr_methodConsideration',
    subLabel:
      '(For example, "I thought about taking an overdose but I never worked out the details about when, where, and how I would do that and I would never act on these thoughts.")',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_methodConsideration_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_methodConsideration_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you had any intention of acting on these thoughts of killing yourself, as opposed to you have the thoughts, but you definitely would not act on them?',
    field: 'ssr_suicidalIntent',
    subLabel:
      '(For example, "I had the thought of killing myself by taking an overdose and am not sure whether I would do it or not.")',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_suicidalIntent_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_suicidalIntent_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you started to work out, or actually worked out, the specific details of how to kill yourself and did you actually intend to carry out the details of your plan?',
    field: 'ssr_suicidePlanWithIntent',
    subLabel:
      '(For example, "I am planning to take 3 bottles of my sleep medication this Saturday when no one is around to stop me.")',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_suicidePlanWithIntent_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_suicidePlanWithIntent_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you ever done anything, started to do anything, or prepared to do anything to end your life?',
    field: 'ssr_suicideAttemptHistory',
    subLabel:
      "(For example: Took pills, tried to shoot yourself, cut yourself, tried to hang yourself, took out pills but didn't swallow any, held a gun but changed your mind about hurting yourself or it was grabbed from your hand, went to the roof to jump but didn't, collected pills, obtained a gun, gave away valuables, wrote a will or suicide note; etc.)",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_suicideAttemptHistory_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_suicideAttemptHistory_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you ever done anything, started to do anything, or prepared to do anything to end your life?',
    field: 'ssr_suicideAttemptHistory',
    subLabel:
      "(For example: Took pills, tried to shoot yourself, cut yourself, tried to hang yourself, took out pills but didn't swallow any, held a gun but changed your mind about hurting yourself or it was grabbed from your hand, went to the roof to jump but didn't, collected pills, obtained a gun, gave away valuables, wrote a will or suicide note; etc.)",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_suicideAttemptHistory_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_suicideAttemptHistory_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Did this occur in the past 3 months?',
    field: 'ssr_recentAttempt',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ssr_recentAttempt_yes',
          value: 'Yes'
        },
        {
          key: 'ssr_recentAttempt_no',
          value: 'No'
        }
      ]
    }
  }
];
export default questionsModels;
